var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _this = this;
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MESSAGETYPES, sendToHost } from 'conversional-iframe-communication';
import { CommonActions, CommonSelectors, JourneysSelectors, useAppDispatch, useAppSelector, } from 'conversional-journey';
import { CTA_TYPES, TrustPulse as TrustPulseContainer } from 'conversional-components';
import { getItem, setItem } from 'conversional-persistent-storage';
import { addCallbacks } from 'conversional-callbacks';
import * as CALL_TO_ACTIONS from '../constants/callToActions';
import { useListener } from '../utils/listener';
var TIME_TO_LIVE = 86400000;
var OPEN = {
    border: 'none',
    position: 'fixed',
    left: '10px',
    bottom: '30px',
    height: '115px',
    width: '330px',
    zIndex: 2147483600,
};
var callbacks = [
    {
        on: 'TrustPulse.completed',
        trigger: 'onClose',
    },
    {
        on: 'TrustPulse.started',
        trigger: 'onTrigger',
    },
    {
        on: 'TrustPulse.clicked',
        trigger: 'onClick',
    },
];
var CTA_TYPE = CTA_TYPES.TRUST_PULSE;
/**
 * ExitIntentMobile View
 * appears once
 * permanently remebers its previous show state
 **/
var TrustPulse = function (_a) {
    var onApplyStyles = _a.onApplyStyles, trustPulseProps = __rest(_a, ["onApplyStyles"]);
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var journeyId = useAppSelector(JourneysSelectors.currentJourneyId);
    var activeCTA = useAppSelector(CommonSelectors.selectActiveCTA);
    var isOtherCTAActive = function () { return activeCTA && activeCTA !== CTA_TYPE; };
    var dispatch = useAppDispatch();
    var flag = "conversional-trust-pulse-".concat(journeyId);
    var destroy = function () {
        sendToHost.destroy();
        dispatch(CommonActions.broadcastSharedStoreChange({
            activeCTA: null,
        }));
        setItem(flag, 'true', { ttl: TIME_TO_LIVE });
    };
    useListener(MESSAGETYPES.JOURNEY_SHOW_ENTRY, destroy);
    useListener(MESSAGETYPES.JOURNEY_SHOW_RESULT, destroy);
    React.useEffect(function () {
        if (hideTrustPulse()) {
            destroy();
        }
        // Regular callbacks
        var supportedCallbacks = {
            onCloseCallback: close,
            onClickCallback: click,
            onTriggerCallback: trigger,
        };
        addCallbacks(_this, callbacks || {}, supportedCallbacks);
    }, []);
    var trigger = function () {
        if (isOtherCTAActive())
            return;
        dispatch(CommonActions.broadcastSharedStoreChange({
            activeCTA: CTA_TYPE,
        }));
        sendToHost.styleIframe(OPEN, true);
        onApplyStyles();
    };
    var click = function () {
        dispatch(CommonActions.logCta(CALL_TO_ACTIONS.TRUST_PULSE));
        sendToHost.publish(MESSAGETYPES.JOURNEY_SHOW_ENTRY);
        close();
    };
    var close = function () {
        destroy();
    };
    var hideTrustPulse = function () {
        return getItem(flag) === 'true';
    };
    return (_jsx(React.Fragment, { children: !hideTrustPulse() && _jsx(TrustPulseContainer, __assign({ theme: theme }, trustPulseProps)) }));
};
export default TrustPulse;
